import { DateTime } from "luxon";

import { generateLongDateAtTimeString } from "@/domains/date/date";

// Whether a creation-date commit was clamped, and by which bound.
// "none" — the user's input was committed as-is.
// "upper" — input was snapped down to the first-edit cap (immutable insert moment).
// "lower" — input was snapped up to the 1970-01-01 epoch floor.
export type CreatedDateCap = "none" | "upper" | "lower";

type Surface = "date" | "time";

const NON_CAPPED_COPY: Record<Surface, string> = {
  date: "Updated creation date",
  time: "Updated creation time",
};

// Both the date popover and the time popover surface identical capped-copy strings
// (the cap reason is the same; only the editor surface differs). This shared util
// keeps those strings in one place so future copy tweaks land in a single file.
export const resolveCreatedToast = ({
  surface,
  cap,
  nextDt,
}: {
  surface: Surface;
  cap: CreatedDateCap;
  nextDt: DateTime;
}): string => {
  const dateAtTime = generateLongDateAtTimeString(nextDt);
  switch (cap) {
    case "upper":
      return `Creation date can't be after the first edit. Set to ${dateAtTime}.`;
    case "lower":
      return `Creation date can't be set before Jan 1, 1970. Set to ${dateAtTime}.`;
    case "none":
      return NON_CAPPED_COPY[surface];
  }
};
